import React from 'react';

import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';

import {
  getSelectedBranches,
  onToggleBulkDeleteSelectionMode,
  getIsInSelectionMode,
  openBulkDeleteBranchesDialog,
} from 'src/redux/branches';
import { publishUiEvent } from 'src/utils/analytics/publish';

import messages from './bulk-delete-branches-actions.i18n';
import * as styles from './bulk-delete-branches-actions.styled';

export const DeleteSelectedBranchesActions = () => {
  const dispatch = useDispatch();
  const selectedBranches = useSelector(getSelectedBranches);
  const isInSelectionMode = useSelector(getIsInSelectionMode);

  const handleDeleteButtonClick = () => {
    dispatch(openBulkDeleteBranchesDialog(false));
    publishUiEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'deleteSelectedBranches',
      source: 'branchesScreen',
      attributes: {
        stale: false,
      },
    });
  };

  return isInSelectionMode ? (
    <styles.DeleteSelectedBranchesActionsWrapper>
      <FormattedHTMLMessage
        {...messages.selectedBranchesCountLabel}
        values={{
          count: selectedBranches.length,
        }}
      />
      <CustomThemeButton
        onClick={() => handleDeleteButtonClick()}
        isDisabled={selectedBranches.length === 0}
        appearance="link"
      >
        <FormattedMessage {...messages.deleteButtonLabel} />
      </CustomThemeButton>
      <styles.CancelButtonWrapper>
        <CustomThemeButton
          onClick={() => dispatch(onToggleBulkDeleteSelectionMode(false))}
          appearance="subtle-link"
        >
          <FormattedMessage {...messages.cancelButtonLabel} />
        </CustomThemeButton>
      </styles.CancelButtonWrapper>
    </styles.DeleteSelectedBranchesActionsWrapper>
  ) : null;
};
